import Api from '@/api/api.js'
import config_api from '@/api/config/_api_config'

const options = access_token => ({ timeout: 20000, med_access_scoped: true, headers: { 'X-Constantes-Config': access_token } })
export default {
    getConstantesCatalogueAccess() {
        return config_api().post('/parametres/constantes-access', {}, { timeout: 20000, constantes_config_scoped: true }).then(response => response.data)
    },
    getConstantesCatalogue(access_token) {
        return Api().get('/parametres/constantes/catalogue', options(access_token)).then(response => response.data)
    },
    saveConstantesCatalogue(data, access_token) {
        return Api().put('/parametres/constantes/catalogue', { base_etag: data.base_etag, fields: data.fields }, options(access_token)).then(response => response.data)
    },
    // Display colours of the vital-signs chart, outside the versioned catalogue.
    getSurveillanceCouleurs(access_token) {
        return Api().get('/parametres/constantes/surveillance-couleurs', options(access_token)).then(response => response.data)
    },
    saveSurveillanceCouleurs(couleurs, access_token) {
        return Api().put('/parametres/constantes/surveillance-couleurs', { couleurs }, options(access_token)).then(response => response.data)
    }
}
